module.exports = __webpack_public_path__ + "fonts/Play-Bold.8012b5f2.woff";